// Derives the business-line label from a contract's event_type.
// Keep this mapping in sync with backend if ever needed server-side.
export const getBusinessLine = (eventType) => {
  switch (eventType) {
    case 'tournament':
    case 'onsite':
      return 'Golf Club';
    case 'offsite':
    case 'pickup':
    case 'dropoff':
      return 'Catering';
    case 'cocktail_coach':
      return 'Wedding';
    default:
      return 'Other';
  }
};

export const BUSINESS_LINES = ['Golf Club', 'Catering', 'Wedding'];

export const businessLineColor = (line) => {
  switch (line) {
    case 'Golf Club': return 'bg-green-100 text-green-800 border-green-300';
    case 'Catering': return 'bg-blue-100 text-blue-800 border-blue-300';
    case 'Wedding': return 'bg-pink-100 text-pink-800 border-pink-300';
    default: return 'bg-gray-100 text-gray-700 border-gray-300';
  }
};
